import React from 'react'
import {
  focusNextElementInList,
  focusPreviousElementInList,
} from '../../select.helpers'
import { useKeybind } from '../../../../../hooks'

/**
 *  This Hook Gives a button element the same functionality
 *  as the HTML Native <option> element
 * @warning Three Conditions must be satisfied in order for this hook to work:
 *
 * 1:   It must be in a Component whose container is a focusable element
 *
 * 2:   It must be a direct sibling to another focusable element that contains this hook
 *
 * 3:   The list must contain only focusable elements
 *        - i.e. If you have a list of buttons and a loader at the end, wrap the list of options in a div.
 */
const useOption = (
  buttonRef: React.RefObject<HTMLElement | null>,
  handleSelect: () => void,
) => {
  useKeybind(['Enter'], handleSelect, buttonRef)
  useKeybind(['Space'], handleSelect, buttonRef)
  // prettier-ignore
  useKeybind(['ArrowUp'], () => focusPreviousElementInList(buttonRef), buttonRef)
  useKeybind(['ArrowDown'], () => focusNextElementInList(buttonRef), buttonRef)
}

export default useOption
